










import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "ProviderInfo",
  components: { BaseAvatar },
  props: {
    provider: { type: Object as PropType<UserPublicData>, required: true },
    itemsCount: { type: Number, default: 0 },
  },
  setup() {
    return { resolveUserName, getProfileUrl };
  },
});
